/**
 * Narrows a transaction list down to a single billing entity.
 *
 * GET /transaction only filters by `issuer`, the professional's paymentId,
 * which is shared by every one of their payment configurations — so splitting
 * the histories by company has to happen on the client. Transactions are
 * created with the `configId` they are issued under, but that field is not part
 * of the documented response, so it is treated as best effort: a list where no
 * item carries it is returned untouched, and so are individual items without
 * it. The histories therefore never hide a movement they cannot attribute.
 */

/** Reads the configuration id off a transaction, whatever casing it arrives in. */
function transactionConfigId(transaction: any): string | undefined {
  return transaction?.configId ?? transaction?.config_id ?? undefined;
}

export function filterTransactionsByConfiguration<T>(
  transactions: T[] | null | undefined,
  configId: string | undefined
): T[] | null | undefined {
  if (!configId || !transactions?.length) return transactions;
  if (!transactions.some(transaction => transactionConfigId(transaction))) {
    return transactions;
  }
  return transactions.filter(transaction => {
    const id = transactionConfigId(transaction);
    return !id || id === configId;
  });
}
